<template>
  <div>


    <el-row class="container">
      <!-- 头部 -->
      <el-col :span="24" class="header">
        <el-col :span="4" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
          {{ collapsed ? '' : sysName }}
        </el-col>

        <!-- 公告图片 -->
        <el-col :span="1">
          <!-- <img src="../assets/notice.gif" alt="GIF" class="gif-image"> -->
        </el-col>
        <el-col :span="15">
          <div id="center-bottom-board" style="margin-right: 25px; margin-left: 10px;">
            <marquee-scroll :duration="5000">
              <img src="../assets/notice1.png" alt="PNG" class="png-image">
              <span>{{ items[0] }}</span>
            </marquee-scroll>
          </div>
        </el-col>
        <el-col :span="4" class="userinfo">
          <!-- 消息图标 -->
          <div class="message-icon" @click="showMessagess">
            <div class="icon-wrapper" v-if="unreadMessages.length > 0">
              <i class="el-icon-chat-line-round"></i>
              <span class="red-dot"></span>
            </div>
            <i v-else class="el-icon-chat-round" style="font-size: 25px"></i>
          </div>

          <!-- 用户信息下拉菜单 -->
          <el-dropdown trigger="hover" placement="bottom-end">
            <div class="userinfo-inner el-dropdown-link">
              <div class="name-wrapper">{{ sysUserName }}</div>
              <div class="avatar-wrapper">
                <img :src="sysUserAvatar || defaultAvatar" :class="{ shake: isNewMessage }" />
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="messages" @click.native="showMessagess">
                我的消息
                <el-badge v-if="unreadMessages.length > 0" :value="unreadMessages.length" />
              </el-dropdown-item>
              <el-dropdown-item @click.native="setup">个人中心</el-dropdown-item>
              <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-col>

      <!-- 主体内容 -->
      <el-col :span="24" class="main">
        <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
          <!--导航菜单-->
          <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose"
                   @select="handleselect"
                   unique-opened router v-show="!collapsed">
            <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
              <el-submenu :index="index+''" v-if="!item.leaf">
                <template slot="title"><i :class="item.iconCls"></i>{{ item.name }}</template>
                <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">
                  {{ child.name }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i
                  :class="item.iconCls"></i>{{ item.children[0].name }}
              </el-menu-item>
            </template>
          </el-menu>
          <!--导航菜单-折叠后-->
          <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
            <li v-for="(item,index) in $router.options.routes" v-if="!item.hidden" class="el-submenu item">
              <template v-if="!item.leaf">
                <div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)"
                     @mouseout="showMenu(index,false)"><i :class="item.iconCls"></i></div>
                <ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)"
                    @mouseout="showMenu(index,false)">
                  <li v-for="child in item.children" v-if="!child.hidden" :key="child.path" class="el-menu-item"
                      style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''"
                      @click="$router.push(child.path)">{{ child.name }}
                  </li>
                </ul>
              </template>
              <template v-else>
                <ul>
                  <li class="el-submenu">
                    <div class="el-submenu__title el-menu-item"
                         style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;"
                         :class="$route.path==item.children[0].path?'is-active':''"
                         @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
                  </li>
                </ul>
              </template>
            </li>
          </ul>
        </aside>

        <!--历史任务栏-->
        <div class="history-taskbar" ref="historyTaskbar">
          <transition-group name="fade" tag="div" class="history-taskbar-container">
            <el-tag
                v-for="(item, index) in filteredHistoryTaskbar"
                :key="item.path"
                :closable="true"
                @close="removeFromHistory(index)"
                :type="$route.path === item.path ? 'primary' : 'info'"
                :effect="$route.path === item.path ? 'dark' : null"
                class="history-item"
                @click="navigateToPage(item.path)"
                :style="$route.path === item.path ? 'padding-left: 25px; position: relative;' : 'padding-left: 10px; position: relative;'"
            >
              <span v-if="$route.path === item.path" class="dot"></span>
              {{ item.name }}
            </el-tag>
          </transition-group>
        </div>

        <div class="right_body main-container">
          <section class="content-container">
            <div class="grid-content bg-purple-light">
              <!-- 面包屑导航 -->
              <el-col :span="24" class="breadcrumb-container">
                <strong class="title">{{ $route.name }}</strong>
                <el-breadcrumb separator="/" class="breadcrumb-inner">
                  <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                    {{ item.name }}
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </el-col>

              <!-- 页面主体内容 -->
              <el-col :span="24" class="content-wrapper">
                <transition name="fade" mode="out-in">
                  <keep-alive :include="$store.state.cache.cachedViews">
                    <router-view />
                  </keep-alive>

                </transition>
              </el-col>
            </div>
          </section>
        </div>
      </el-col>
    </el-row>


    <!-- 抽屉组件，用于显示消息 -->
    <el-drawer
        :visible.sync="drawerVisible"
        size="30%"
        direction="rtl"
        :with-header="false"
    >
      <div class="drawer-header">
        <h3 class="drawer-title">消息中心</h3>
        <div v-if="messages.length > 0" class="clear-all-button">
          <el-button
              type="danger"
              size="mini"
              @click="clearAllMessages"
          >
            清空所有消息
          </el-button>
        </div>
      </div>
      <div v-if="messages.length > 0">
        <div
            v-for="(message, index) in messages"
            :key="index"
            class="message-container"
        >
          <p class="message-time">{{ message.infoTime }}</p>
          <el-card class="message-card" :body-style="{ padding: '20px' }">
            <el-button
                class="delete-button"
                type="text"
                size="mini"
                icon="el-icon-delete"
                @click="deleteMessage(message.id)"
            ></el-button>
            <div class="message-content-wrapper">
              <el-tag class="message-tag" type="success">{{ message.infoType }}</el-tag>
              <p class="message-content">{{ message.infoContent }}</p>
            </div>
          </el-card>
        </div>
      </div>
      <div v-else >
        <el-empty description="当前没有消息"></el-empty>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import '../assets/css/homeStyles.css'
import { Notification } from 'element-ui';
import routeCache from '../utils/routeCacheMiddleware'

import MarqueeScroll from './MarqueeScroll.vue'
export default {
  components: {
    MarqueeScroll
  },
  watch: {
    $route(to, from) {
      this.updateHistoryTaskbar();
    },
    historyTaskbar: {
      handler(newHistoryTaskbar) {
        if (newHistoryTaskbar.length === 0) {
          this.$router.push('/echarts');
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      drawerVisible: false,
      cachedViews: [],
      messages: [],
      isMenuVisible: false,
      unreadMessages: [],
      isNewMessage: false,
      shakeInterval: null,
      defaultAvatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
      sysName: '空气虫',
      collapsed: false,
      sysUserName: '',
      sysUserAvatar: '',
      historyTaskbar: [],
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      items: [],
      currentPosition: 0,
      totalWidth: 0,
      animationId: null,
      scrollSpeed: 1,
      eventSource: null,
      reconnectAttempts: 0,
      // SSE 连接状态
      sseConnectionStatus: 'disconnected', // connecting, connected, disconnected
      sseStatusMessage: ''
    }
  },
  computed: {
    filteredHistoryTaskbar() {
      const excludedRoutes = ['/CustomeraAddorder', '/OrderToAddCustomer', '/MyToAddCustomer','/examine'];
      return this.historyTaskbar.filter((item) => !excludedRoutes.includes(item.path));
    }
  },
  created() {
    // 页面创建时立即启动 SSE 连接
    this.$nextTick(() => {
      this.connectToServer();
    });
  },
  mounted() {
    this.getMessages();
    // this.$nextTick(() => {
    //   this.move();
    // });
    const logininfo = localStorage.getItem('logininfo');
    if (logininfo) {
      let logininfoObj = JSON.parse(logininfo);
      this.sysUserName = logininfoObj.username;
      this.sysUserAvatar = logininfoObj.avatar;
    }

    if (this.historyTaskbar.length === 0 && !this.$route.path) {
      this.$router.push('/echarts');
    }

    // 显示 SSE 连接状态
    this.showConnectionStatus();
  },
  beforeDestroy() {
    if (this.eventSource) {
      this.eventSource.close();
    }
    clearInterval(this.shakeInterval);
  },
  methods: {

    getMessages() {
      const logininfo = JSON.parse(localStorage.getItem("logininfo"));
      const loginId = logininfo.id;
      this.$http.get('/info/getMyInfo/', { params: { loginId: loginId } }).then((res) => {
        this.messages = res.data.map(message => {
          message.infoTime = this.$formatTimeNew(message.infoTime);
          return message;
        });
      });
    },
    showMessagess() {
      this.drawerVisible = true;
      this.getMessages();
      if(this.isNewMessage) {
        this.unreadMessages = [];
        this.stopShaking();
      }
    },
    clearAllMessages() {
      const messageIds = this.messages.map(message => message.id);
      this.$http.patch('/info', messageIds).then(() => {
        this.messages = [];
        this.$message.success('所有消息已清空');
      }).catch((error) => {
        console.error('清空所有消息失败', error);
      });
    },
    deleteMessage(messageId) {
      this.$http.delete(`/info/${messageId}`).then(() => {
        this.messages = this.messages.filter(message => message.id !== messageId);
        this.$message.success('消息已删除');
      }).catch((error) => {
        console.error('删除消息失败', error);
      });
    },
    connectToServer() {
      if (this.eventSource) {
        this.eventSource.close();
      }

      const logininfo = JSON.parse(localStorage.getItem("logininfo"));
      const userId = logininfo.id;

      // 显示连接中状态
      this.showConnectingStatus();

      this.eventSource = new EventSource(`https://www.kongqichong.com/sse/store/${userId}`);
      // this.eventSource = new EventSource(`http://localhost:8080/sse/store/${userId}`);

      this.eventSource.onopen = () => {
        console.log('SSE连接成功');
        this.showConnectedStatus();
        this.reconnectAttempts = 0; // 重置重连次数
      };

      this.eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'announcement') {
            this.items = [];
            this.items.push(data.content);
            // this.$nextTick(() => {
            //   this.move();
            // });
          } else if (data.type === 'order') {
            this.unreadMessages.push(data.content);
            if (!this.isNewMessage) {
              this.startShaking();
            }
            Notification({
              title: '新消息',
              message: data.content,
              type: 'info',
              duration: 3000,
              offset: 50,
            });
          }
        } catch (e) {
          console.error('SSE消息解析失败:', e);
        }
      };

      this.eventSource.onerror = (error) => {
        const readyState = this.eventSource.readyState;
        console.warn(`SSE连接遇到问题: 状态 ${readyState}, 错误: ${error.message || '无详细信息'}`);

        this.showDisconnectedStatus();

        if (readyState === EventSource.CLOSED || readyState !== EventSource.OPEN) {
          this.reconnectToServer();
        }
      };
    },
    reconnectToServer() {
      if (this.reconnectAttempts < 5) {
        this.reconnectAttempts++;
        const delay = Math.min(5000 * this.reconnectAttempts, 30000); // 最大30秒间隔
        console.log(`尝试重新连接SSE... (${this.reconnectAttempts}/5), ${delay}ms后重试`);

        setTimeout(() => {
          this.connectToServer();
        }, delay);
      } else {
        console.error('达到最大重连次数，停止重连');
        this.$message.error('SSE连接失败，请刷新页面重试');
      }
    },
    showMessages() {
      if(this.unreadMessages.length == 0){
        this.$message.warning('暂时没有新的消息!')
      } else {
        this.unreadMessages.forEach((message, index) => {
          this.showNotification(message, index);
        });
        this.unreadMessages = [];
        this.stopShaking();
      }
    },
    showNotification(messageContent, index) {
      this.$notify({
        title: '新消息',
        message: messageContent,
        type: 'success',
        duration: 0,
        offset: 60 + index * 100
      });
    },
    startShaking() {
      this.isNewMessage = true;
      this.shakeInterval = setInterval(() => {
        this.isNewMessage = !this.isNewMessage;
      }, 3000);
    },
    stopShaking() {
      this.isNewMessage = false;
      clearInterval(this.shakeInterval);
    },
    // move() {
    //   let wrapper = this.$refs.wrapper;
    //   let wrapperWidth = wrapper.getBoundingClientRect().width;
    //   let marquee = this.$refs.marquee;
    //   let marqueeContent = this.$refs.marqueeContent;
    //   let contentWidth = marqueeContent.getBoundingClientRect().width;
    //   let distance = wrapperWidth;
    //   let moveSpeed = 1;
    //   setInterval(() => {
    //     if (marquee && marqueeContent && wrapper) {
    //       if (marquee.getBoundingClientRect().x + contentWidth < wrapper.getBoundingClientRect().x) {
    //         distance = wrapperWidth;
    //       }
    //       distance -= moveSpeed;
    //       marquee.style.transform = 'translateX(' + distance + 'px)';
    //     }
    //   }, 20);
    // },
    updateHistoryTaskbar() {
      const routeInfo = {
        name: this.$route.name,
        path: this.$route.path,
        timestamp: Date.now(),
      };
      const existingIndex = this.historyTaskbar.findIndex(
          (item) => item.path === routeInfo.path
      );
      if (existingIndex === -1) {
        this.historyTaskbar.push(routeInfo);
      }
    },
    removeFromHistory(index) {
      const removedItem = this.historyTaskbar.splice(index, 1)[0]

      if (removedItem.name) {
        // 删除 Vuex cachedViews
        this.$store.commit('cache/REMOVE_CACHE', removedItem.name)
      }

      // 删除 routeCacheMiddleware 中的数据

      routeCache.remove({ path: removedItem.path, query: removedItem.query || {} })

      // 跳转逻辑
      if (this.historyTaskbar.length > 0) {
        const lastPath = this.historyTaskbar[this.historyTaskbar.length - 1].path
        if (this.$route.path === removedItem.path) {
          this.$router.push({ path: lastPath })
        }
      } else {
        this.$router.push('/echarts')
      }
    },

    navigateToPage(path) {
      this.$router.push({path: path, query: {_refresh: Date.now()}});
    },
    handleopen() {},
    handleclose() {},
    handleselect() {},
    setup() {
      this.$router.push('/AccountMag');
    },
    logout() {
      this.$confirm('确认退出吗?', '提示', {}).then(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('logininfo');
        localStorage.removeItem('permissions');
        localStorage.removeItem('menus');
        localStorage.removeItem("lastCustomerId");
        this.$router.push('/login');
      }).catch(() => {});
    },
    collapse() {
      this.collapsed = !this.collapsed;
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
    },

    // SSE 状态管理方法
    showConnectionStatus() {
      // 可以在这里添加 UI 状态显示逻辑
      console.log('当前SSE连接状态:', this.sseConnectionStatus);
    },

    showConnectingStatus() {
      this.sseConnectionStatus = 'connecting';
      this.sseStatusMessage = '正在连接消息服务...';
      console.log(this.sseStatusMessage);
    },

    showConnectedStatus() {
      this.sseConnectionStatus = 'connected';
      this.sseStatusMessage = '消息服务连接成功';
      console.log(this.sseStatusMessage);
      // 3秒后清除状态消息
      setTimeout(() => {
        this.sseStatusMessage = '';
      }, 3000);
    },

    showDisconnectedStatus() {
      this.sseConnectionStatus = 'disconnected';
      this.sseStatusMessage = '消息服务连接断开';
      console.warn(this.sseStatusMessage);
    }
  }
}
</script>

<style>
/* 保持原有样式不变 */
</style>



// WEBPACK FOOTER //
// Home.vue?746eb369